// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiTypography-root.leadDetailHeading {
  color: #383939;
  margin-top: 24px;
  width: 100%;
  display: flex;
}
`, "",{"version":3,"sources":["webpack://./src/components/LeadDetails/styles.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,aAAa;AACf","sourcesContent":[".MuiTypography-root.leadDetailHeading {\n  color: #383939;\n  margin-top: 24px;\n  width: 100%;\n  display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
